var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broadcast-html"},[_c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('feed'),_c('index')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }